import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttp } from '../../../../../../core/classes/abstract-http';
import { environment } from '../../../../../../../environments/environment';

@Injectable()
export class CustomerDeleteService extends AbstractHttp {

  constructor(http: HttpClient) {
  
    const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.CustomerDelete}`;
    super(http, url);
  }
}
